// test2449
(2449 && 0);
